"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const DEBUG_MODE = false;
const REGEXP_SCROLL_PARENT = /^(visible|hidden)/;
const consoleLog = function () {
  if (!DEBUG_MODE) {
    return;
  }
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  console.trace("[Scroll Manager]: ", ...args);
};
const isScrollable = function (element) {
  return element.scrollHeight > element.clientHeight && !REGEXP_SCROLL_PARENT.test(window.getComputedStyle(element).overflowY || "visible") || element.scrollWidth > element.clientWidth && !REGEXP_SCROLL_PARENT.test(window.getComputedStyle(element).overflowX || "visible");
};
const getScrollParent = function (el, boundary) {
  let checkParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isScrollable;
  if (!(el instanceof HTMLElement) || typeof window.getComputedStyle !== "function") {
    return null;
  }
  if (boundary && el !== boundary && !(boundary !== null && boundary !== void 0 && boundary.contains(el))) {
    return null;
  }
  if (checkParent(el)) {
    return el;
  } else {
    return getScrollParent(el.parentElement, boundary, checkParent) || (!boundary ? document.documentElement : null);
  }
};

/**
 * @param {Element}  element - HTML element to scroll to.
 * @param {object=} options - Object of options to configure how scrollToElement works
 * @param {(Element) => boolean=} options.checkParent - Provides element while scanning the document tree to find a scrollable parent. Overrides the default function for checking the availability to scroll
 * @param {Element=} options.boundary - Sets upper limit of how far to scan up the document tree, if this isn't provided it'll scan to the root and default to documentElement
 * @param {Element=} options.parent - Sets specific parent use for scrolling
 * @returns {void}
 */
const scrollToElement = function (element) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const parent = (options === null || options === void 0 ? void 0 : options.parent) || getScrollParent(element, options === null || options === void 0 ? void 0 : options.boundary, options === null || options === void 0 ? void 0 : options.checkParent);
  if (!parent) {
    consoleLog("No valid parent found");
    return;
  }
  const parentStyles = window.getComputedStyle(parent);
  const elmentStyles = window.getComputedStyle(element);
  const scrollPaddingY = parseInt(parentStyles.scrollPaddingTop, 10) || 0;
  const scrollMarginY = parseInt(elmentStyles.scrollMarginTop, 10) || 0;
  const scrollPaddingX = parseInt(parentStyles.scrollPaddingLeft, 10) || 0;
  const scrollMarginX = parseInt(elmentStyles.scrollMarginLeft, 10) || 0;
  let scrollToY = 0,
    scrollToX = 0;
  if (document.documentElement === parent) {
    const boundingBox = element.getBoundingClientRect();
    scrollToY = boundingBox.top + window.scrollY - scrollPaddingY - scrollMarginY;
    scrollToX = boundingBox.left + window.scrollX - scrollPaddingX - scrollMarginX;
  } else {
    scrollToY = element.offsetTop - parent.offsetTop - scrollPaddingY - scrollMarginY;
    scrollToX = element.offsetLeft - parent.offsetLeft - scrollPaddingX - scrollMarginX;
  }
  parent.scrollTo({
    top: scrollToY,
    left: scrollToX,
    behavior: "smooth"
  });
  if (DEBUG_MODE) {
    consoleLog("Triggered scroll | Parent:", parent, "Child:", element);
  }
};
var _default = exports.default = scrollToElement;